function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { cssVar, defineStyle, defineStyleConfig, getCSSVar, SkeletonText as ChakraSkeletonText } from "../chakra/internal";
const $startColor = cssVar('skeleton-start-color');
const $endColor = cssVar('skeleton-end-color');
const baseStyle = defineStyle(({ theme })=>{
    const varColors = {
        [$startColor.variable]: getCSSVar(theme, 'colors', 'background.neutral.tertiary.default'),
        [$endColor.variable]: getCSSVar(theme, 'colors', 'background.neutral.tertiary.disabled')
    };
    return _object_spread_props(_object_spread({}, varColors), {
        _light: varColors,
        _dark: varColors,
        background: 'background.neutral.tertiary.default',
        borderColor: 'background.neutral.tertiary.disabled',
        animation: '0.8s linear infinite alternate'
    });
});
export const ThemedSkeleton = defineStyleConfig({
    baseStyle
});
export const SkeletonText = (props)=>{
    return /*#__PURE__*/ _jsx(ChakraSkeletonText, _object_spread({
        speed: 0.8
    }, props));
};

//# sourceMappingURL=Skeleton.js.map